(() => {
  const FREE_SHIP_CENTS = 7500;
  const money = (cents) => {
    const n = Number(cents || 0) / 100;
    return `$${n.toFixed(2)}`;
  };

  const drawer = document.querySelector("[data-lp-cart-drawer]");
  if (!drawer) return;

  const itemsEl = drawer.querySelector("[data-lp-cart-items]");
  const footEl = drawer.querySelector("[data-lp-cart-foot]");
  const subtotalEl = drawer.querySelector("[data-lp-cart-subtotal]");
  const shippingEl = drawer.querySelector("[data-lp-cart-shipping]");
  const countEls = () => document.querySelectorAll(".lp-site-header__cart-count");

  let cartState = null;

  const setOpen = (open) => {
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    document.documentElement.classList.toggle("lp-cart-open", open);
  };

  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  const updateCounts = (count) => {
    countEls().forEach((el) => {
      el.textContent = String(count || 0);
      el.hidden = !count;
    });
  };

  const renderShipping = (totalCents) => {
    if (!shippingEl) return;
    const left = Math.max(0, FREE_SHIP_CENTS - totalCents);
    const pct = Math.min(100, Math.round((totalCents / FREE_SHIP_CENTS) * 100));
    shippingEl.hidden = false;
    if (left <= 0) {
      shippingEl.innerHTML = `<strong>You've unlocked FREE shipping!</strong><div class="lp-cart-drawer__bar"><span style="width:100%"></span></div>`;
    } else {
      shippingEl.innerHTML = `You're <strong>${money(left)}</strong> away from FREE shipping<div class="lp-cart-drawer__bar"><span style="width:${pct}%"></span></div>`;
    }
  };

  const render = (cart) => {
    cartState = cart;
    updateCounts(cart.item_count);

    if (!cart.item_count) {
      itemsEl.innerHTML = `<p class="lp-cart-drawer__empty">Your cart is empty.</p>`;
      footEl.hidden = true;
      shippingEl.hidden = true;
      return;
    }

    itemsEl.innerHTML = cart.items
      .map((item, idx) => {
        const line = idx + 1;
        const img = item.image
          ? `<img src="${item.image}" alt="" width="72" height="72" loading="lazy">`
          : `<div class="lp-cart-drawer__ph"></div>`;
        return `
        <div class="lp-cart-drawer__item" data-line="${line}" data-key="${item.key}">
          <a class="lp-cart-drawer__thumb" href="${item.url}">${img}</a>
          <div class="lp-cart-drawer__meta">
            <a class="lp-cart-drawer__name" href="${item.url}">${item.product_title}</a>
            <p class="lp-cart-drawer__variant">${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}</p>
            <div class="lp-cart-drawer__row">
              <div class="lp-cart-drawer__qty" data-lp-qty>
                <button type="button" data-qty-change="-1" aria-label="Decrease">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-qty-change="1" aria-label="Increase">+</button>
              </div>
              <strong>${money(item.final_line_price)}</strong>
            </div>
            <button type="button" class="lp-cart-drawer__remove" data-qty-set="0">Remove</button>
          </div>
        </div>`;
      })
      .join("");

    subtotalEl.textContent = money(cart.total_price);
    footEl.hidden = false;
    renderShipping(cart.total_price);
  };

  const fetchCart = () =>
    fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json()).then((cart) => {
      render(cart);
      return cart;
    });

  const changeLine = (line, quantity) =>
    fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        render(cart);
        return cart;
      });

  const addVariant = (id, quantity = 1) =>
    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] }),
    }).then(async (r) => {
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || "Could not add to cart");
      return fetchCart();
    });

  // Product form → AJAX + open drawer (official Upcart-like flow)
  document.querySelectorAll("[data-lp-product-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const idInput = form.querySelector("[data-lp-variant-id], [name='id']");
      const id = idInput && idInput.value;
      if (!id) return;
      const label = btn && btn.querySelector("span");
      const prev = label ? label.textContent : btn ? btn.textContent : "";
      if (btn) {
        btn.disabled = true;
        if (label) label.textContent = "Adding…";
        else btn.textContent = "Adding…";
      }
      try {
        await addVariant(id, 1);
        openDrawer();
      } catch (err) {
        console.error(err);
        alert(err.message || "Could not add to cart");
      } finally {
        if (btn) {
          btn.disabled = false;
          if (label) label.textContent = prev || "START YOUR GUT RESET NOW";
          else btn.textContent = prev || "START YOUR GUT RESET NOW";
        }
      }
    });
  });

  // Header cart opens drawer
  document.querySelectorAll(".lp-site-header__cart, [data-lp-cart-open]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      fetchCart().then(openDrawer);
    });
  });

  drawer.querySelectorAll("[data-lp-cart-close]").forEach((el) => {
    el.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });

  itemsEl.addEventListener("click", (e) => {
    const item = e.target.closest(".lp-cart-drawer__item");
    if (!item) return;
    const line = Number(item.dataset.line);
    const qtyBtn = e.target.closest("[data-qty-change]");
    const setBtn = e.target.closest("[data-qty-set]");
    if (qtyBtn) {
      const delta = Number(qtyBtn.getAttribute("data-qty-change"));
      const span = item.querySelector(".lp-cart-drawer__qty span");
      const current = Number(span && span.textContent) || 1;
      changeLine(line, Math.max(0, current + delta));
    } else if (setBtn) {
      changeLine(line, Number(setBtn.getAttribute("data-qty-set")));
    }
  });

  // Prefetch cart count
  fetchCart().catch(() => {});
})();
